import './theme_keskustaksi.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeKeskustaksi implements ITheme {
    id: string = 'keskustaksi';
    matchIfHostNameContainsAny: string[] = ['keskustaksi'];
    name: string = 'Keskustaksi';
    cssClassName: string = 'theme_keskustaksi';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#006FB9',
        secondary: '#dd9933',
        accent: '#e95d0e',
        warning: '#e95d0e',
        bottomNavColor: '#ffffff',
    };
}
